
export const secureStringify = (data) => {
    return JSON.stringify(data, (key, value) => {
        return value || null;
    });
};

export const cleanDictForJson = (data) => {
    return JSON.parse(secureStringify(data));
};
